import { cn } from "@/lib/utils";
import { statusClass } from "@/lib/constants";

export default function StatusBadge({ status, label, className, testid }) {
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap",
        statusClass(status),
        className
      )}
    >
      {label || status || "—"}
    </span>
  );
}
